export class FisCode {
    listId: number;
    fisCode : number;
    firstName: string;
    lastName: string;
    club: string; 
    points: number;
}